'use strict';

angular.module('lingApp')
  .factory('$locale', function(RipContext) {
    var PLURAL_CATEGORY = {ZERO: 'zero', ONE: 'one', TWO: 'two', FEW: 'few', MANY: 'many', OTHER: 'other'};

    return {
      'DATETIME_FORMATS': {
        'AMPMS': [
          'AM',
          'PM'
        ],
        'DAY': [
          'Sunday',
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday',
          'Saturday'
        ],
        'MONTH': [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December'
        ],
        'SHORTDAY': [
          'Sun',
          'Mon',
          'Tue',
          'Wed',
          'Thu',
          'Fri',
          'Sat'
        ],
        'SHORTMONTH': [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec'
        ],
        'fullDate': 'EEEE, MMMM d, y',
        'longDate': 'MMMM d, y',
        'medium': RipContext.timeFormatString,
        'mediumDate': RipContext.dateFormatString,
        'mediumTime': RipContext.timeOnlyFormatString,
        'short': 'M/d/yy h:mm a',
        'shortDate': 'M/d/yy',
        'shortTime': 'h:mm a'
      },
      'NUMBER_FORMATS': {
        'CURRENCY_SYM': RipContext.currencySymbol,
        'DECIMAL_SEP': RipContext.l10nDecimalSeparator,
        'GROUP_SEP': RipContext.l10nGroupingSeparator,
        'PATTERNS': [
          {
            'gSize': 3,
            'lgSize': 3,
            'macFrac': 0,
            'maxFrac': 2,
            'minFrac': 0,
            'minInt': 1,
            'negPre': '-',
            'negSuf': '',
            'posPre': '',
            'posSuf': ''
          },
          {
            'gSize': 3,
            'lgSize': 3,
            'macFrac': 0,
            'maxFrac': 2,
            'minFrac': 2,
            'minInt': 1,
            'negPre': '(\u00a4',
            'negSuf': ')',
            'posPre': '\u00a4',
            'posSuf': ''
          }
        ]
      },
      'id': 'en',
      'pluralCat': function (n) {  if (1 === n) {   return PLURAL_CATEGORY.ONE;  }  return PLURAL_CATEGORY.OTHER; }
    };
  })
;
